/**
 * Canonical klippekort ↔ service eligibility.
 *
 * V2 stores allowed services on punch_cards / punch_card_templates as
 * `appointment_types`: [{ appointmentTypeId: <services.id> }].
 * An empty or missing list means the card applies to every service (V1/V2).
 * Service names are never stored — only existing service IDs.
 * Mirrors private.punch_card_covers_service / public.punch_card_covers_service.
 */

export type PunchCardServiceRef = {
  appointmentTypeId: string;
};

export function parsePunchCardServiceIds(appointmentTypes: unknown): string[] {
  if (!Array.isArray(appointmentTypes)) return [];
  const ids: string[] = [];
  for (const item of appointmentTypes) {
    if (!item || typeof item !== 'object') continue;
    const id = (item as { appointmentTypeId?: unknown }).appointmentTypeId;
    if (typeof id === 'string' && id.length > 0 && !ids.includes(id)) {
      ids.push(id);
    }
  }
  return ids;
}

export function toPunchCardAppointmentTypes(serviceIds: string[]): PunchCardServiceRef[] {
  return parsePunchCardServiceIds(
    serviceIds.map((appointmentTypeId) => ({ appointmentTypeId })),
  ).map((appointmentTypeId) => ({ appointmentTypeId }));
}

export function punchCardAppliesToService(
  appointmentTypes: unknown,
  serviceId: string | null | undefined,
): boolean {
  const allowedIds = parsePunchCardServiceIds(appointmentTypes);
  if (allowedIds.length === 0) return true;
  if (!serviceId) return false;
  return allowedIds.includes(serviceId);
}
